import ProfilePhoto from '../../molecules/profile-photo/profile-photo';
import { WStack } from '../../wrappers/wrapper';
import styles from './user-card.module.scss';
import { CardActionArea, CardContent, Typography } from '@mui/material';

interface UserCardProps {
  user: any;
  index: any;
  width?: string;
  height?: string;
  onClick: () => void;
}

function UserCard({ user, index, width, height, onClick }: UserCardProps) {
  return (
    <WStack className={styles.card} key={user.username + index} onClick={onClick}>
      <CardActionArea>
        <ProfilePhoto user={user} className={styles.profile}/>
        <CardContent>
          <Typography variant="body2">{user.username}</Typography>
          <Typography variant="body2">{user.job || <div>&nbsp;</div>}</Typography>
        </CardContent>
      </CardActionArea>
    </WStack>
  );
}
export default UserCard;
